export default [{
    name: 'Квартира',
    genitiveName: 'Квартиры',
    key: 'flat',
}, {
    name: 'Комната',
    genitiveName: 'Комнаты',
    key: 'room',
}, {
    name: 'Койко-место',
    genitiveName: 'Койко-места',
    key: 'bed',
}, {
    name: 'Дом/Дача',
    genitiveName: 'Дома/Дачи',
    key: 'house',
}, {
    name: 'Коттедж',
    genitiveName: 'Коттеджа',
    key: 'cottage',
}, {
    name: 'Таунхаус',
    genitiveName: 'Таунхауса',
    key: 'townhouse',
}, {
    name: 'Часть дома',
    genitiveName: 'Части дома',
    key: 'houseShare',
}];
